import React, { Component } from 'react';
import Select from 'react-select';
import { isEqual } from 'lodash';

class SelectDeviceOptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOptions: []
    };

    // Do proper bindings
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(selectedOption) {
    // Store the selected sensors list
    this.setState({ selectedOption: selectedOption });
    // selectedOption can be null when the `x`(clear) button is clicked
    this.props.handleDeviceSelect(selectedOption);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.devices, this.props.devices)) {
      this.setState({
        selectedOption: nextProps.devices[0]
      });
    }
  }

  componentDidMount() {
    this.setState({
      selectedOption: this.props.devices[0]
    });
  }

  render() {
    if (!this.props.displayPrimary) {
      return null;
    }
    return (
      <Select
        name="DeviceOptions"
        placeholder="Enheder..."
        value={this.state.selectedOption}
        onChange={this.handleChange}
        isClearable={this.props.isClearable || false}
        isMulti={this.props.isMulti || false}
        options={this.props.devices}
        getOptionLabel={(option) => option.name}
        getOptionValue={(option) => option.device}
        className="basic-multi-select"
        classNamePrefix="select"

      />
    );
  }
}

export default SelectDeviceOptions;